import {
  MAP_INITIAL_LAT,
  MAP_INITIAL_LNG,
  MAP_INITIAL_ZOOM,
} from '@kamernet/constants/Search';

import { areMapCoordsEqual } from './areMapCoordsEqual';

export function isMapInInitialState(
  centerLAT: number,
  centerLNG: number,
  zoom: number,
) {
  return (
    areMapCoordsEqual(MAP_INITIAL_LAT, centerLAT) &&
    areMapCoordsEqual(MAP_INITIAL_LNG, centerLNG) &&
    zoom === MAP_INITIAL_ZOOM
  );
}
